import type { DashboardLayout, DashboardWidgetId, DashboardWidgetLayout } from "./types";

export const ORDER_STATS_FILTER_POPOVER_ID = "ecom-order-stats-filter-popover";

export const DASHBOARD_LAYOUT_VERSION = 2;

export const DASHBOARD_CONTAINERS = ["left", "right"] as const;

export type DashboardContainerId = (typeof DASHBOARD_CONTAINERS)[number];

export const ORDER_FEATURE_FLAGS = [
  "order_sync_shopify_to_etsy",
  "etsy_order_sync_to_shopify",
  "order_sync_etsy_to_shopify",
  "order_sync",
  "orders_sync",
] as const;

export const DEFAULT_WIDGETS: DashboardWidgetLayout[] = [
  { id: "etsy_shop_stats", visible: true, sections: {} },
  { id: "order_stats", visible: true, sections: { orders: true, revenue: true } },
  { id: "listing_stats", visible: true, sections: { shopify: false, etsy: true } },
  // Subscription card only — shown on left after Etsy Shop Stats / Order stats
  { id: "subscription", visible: true, sections: { subscription: true } },
  // Credit usage overview — stays on right
  { id: "credit_usage", visible: true, sections: { limits: true } },
];

export const DEFAULT_DASHBOARD_LAYOUT: DashboardLayout = {
  version: DASHBOARD_LAYOUT_VERSION,
  left: [DEFAULT_WIDGETS[0], DEFAULT_WIDGETS[1], DEFAULT_WIDGETS[3]],
  right: [DEFAULT_WIDGETS[2], DEFAULT_WIDGETS[4]],
};

export const WIDGET_LABELS: Record<DashboardWidgetId, string> = {
  etsy_shop_stats: "Etsy shop stats",
  order_stats: "Order stats",
  listing_stats: "Listing stats",
  subscription: "Subscription",
  credit_usage: "Credit usage",
};

export const SECTION_LABELS: Record<string, string> = {
  orders: "Orders",
  revenue: "Revenue",
  shopify: "Shopify",
  etsy: "Etsy",
  subscription: "Subscription",
  limits: "Limits",
};
